import React from 'react';

function ProductZoekenLijst({
  results,
  loading,
  quantities,
  onQuantityChange,
  excludeProductIds = null,
  emptyMessage = 'Geen producten gevonden.'
}) {
  const producten = excludeProductIds
    ? results.filter((product) => !excludeProductIds.has(String(product.ID)))
    : results;

  if (loading) {
    return <p className="producten-loading">Zoeken...</p>;
  }

  if (producten.length === 0) {
    return <p className="producten-panel-empty">{emptyMessage}</p>;
  }

  return (
    <div className="producten-list">
      {producten.map((product) => (
        <div key={product.ID} className="product-item product-item--zoek">
          <label>
            <span className="product-zoek-naam">
              {product.product} {product.eenheid && `(${product.eenheid})`}
            </span>
            <span className="product-zoek-groep">{product.groep_naam}</span>
          </label>
          <input
            type="number"
            min="0"
            value={quantities[product.ID] || ''}
            onChange={(e) => onQuantityChange(product.ID, e.target.value)}
            placeholder="0"
          />
        </div>
      ))}
    </div>
  );
}

export default ProductZoekenLijst;
